import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/selling-on-kidizen';

export default function Example() {
  return (
    <>
      <Head>
        <title>Selling on Kidizen? Use Promoted Listing To Boost Your Sales!</title>
        <meta
          name='description'
          content='With hundreds of accounts selling on Kidizen, you may find yourself competing with them–trying different ways to get noticed by potential buyers and close deals with them. While there are indeed several strategies you can adopt, what you can focus on in the meantime is doing Promoted Listings.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/selling-on-kidizen' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/selling-on-kidizen' />
        <meta property='og:title' content='Selling on Kidizen? Use Promoted Listing To Boost Your Sales!' />
        <meta
          property='og:description'
          content='With hundreds of accounts selling on Kidizen, you may find yourself competing with them–trying different ways to get noticed by potential buyers and close deals with them. While there are indeed several strategies you can adopt, what you can focus on in the meantime is doing Promoted Listings.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-11-09T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-11-09T00:00:00-00:00' />
        <meta property='article:tag' content='Kidizen' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
